/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VpnApiRouteImport } from './routes/vpn-api'
import { Route as VouchersRouteImport } from './routes/vouchers'
import { Route as TeamRouteImport } from './routes/team'
import { Route as SubscriptionsRouteImport } from './routes/subscriptions'
import { Route as StatusRouteImport } from './routes/status'
import { Route as StatsRouteImport } from './routes/stats'
import { Route as ReferralsRouteImport } from './routes/referrals'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PayoutsRouteImport } from './routes/payouts'
import { Route as MoreRouteImport } from './routes/more'
import { Route as MirrorsRouteImport } from './routes/mirrors'
import { Route as MarketingRouteImport } from './routes/marketing'
import { Route as GiveawaysRouteImport } from './routes/giveaways'
import { Route as FinanceRouteImport } from './routes/finance'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as ClientsRouteImport } from './routes/clients'
import { Route as ClientWithdrawalsRouteImport } from './routes/client-withdrawals'
import { Route as CampaignsRouteImport } from './routes/campaigns'
import { Route as BotsRouteImport } from './routes/bots'
import { Route as BotImportRouteImport } from './routes/bot-import'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BotIndexRouteImport } from './routes/bot.index'
import { Route as WarmupRulesBotIdRouteImport } from './routes/warmup-rules.$botId'
import { Route as OnboardingBotRouteImport } from './routes/onboarding.bot'
import { Route as CampaignsCampaignIdRouteImport } from './routes/campaigns.$campaignId'
import { Route as BotsBotIdRouteImport } from './routes/bots.$botId'
import { Route as BotTemplatesRouteImport } from './routes/bot.templates'
import { Route as BotSettingsRouteImport } from './routes/bot.settings'
import { Route as BotBrandRouteImport } from './routes/bot.brand'
import { Route as BotWarmupBotIdRouteImport } from './routes/bot-warmup.$botId'
import { Route as BotTextsBotIdRouteImport } from './routes/bot-texts.$botId'
import { Route as BotReviewsBotIdRouteImport } from './routes/bot-reviews.$botId'

const VpnApiRoute = VpnApiRouteImport.update({
  id: '/vpn-api',
  path: '/vpn-api',
  getParentRoute: () => rootRouteImport,
} as any)
const VouchersRoute = VouchersRouteImport.update({
  id: '/vouchers',
  path: '/vouchers',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamRoute = TeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => rootRouteImport,
} as any)
const SubscriptionsRoute = SubscriptionsRouteImport.update({
  id: '/subscriptions',
  path: '/subscriptions',
  getParentRoute: () => rootRouteImport,
} as any)
const StatusRoute = StatusRouteImport.update({
  id: '/status',
  path: '/status',
  getParentRoute: () => rootRouteImport,
} as any)
const StatsRoute = StatsRouteImport.update({
  id: '/stats',
  path: '/stats',
  getParentRoute: () => rootRouteImport,
} as any)
const ReferralsRoute = ReferralsRouteImport.update({
  id: '/referrals',
  path: '/referrals',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const PricingRoute = PricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const PayoutsRoute = PayoutsRouteImport.update({
  id: '/payouts',
  path: '/payouts',
  getParentRoute: () => rootRouteImport,
} as any)
const MoreRoute = MoreRouteImport.update({
  id: '/more',
  path: '/more',
  getParentRoute: () => rootRouteImport,
} as any)
const MirrorsRoute = MirrorsRouteImport.update({
  id: '/mirrors',
  path: '/mirrors',
  getParentRoute: () => rootRouteImport,
} as any)
const MarketingRoute = MarketingRouteImport.update({
  id: '/marketing',
  path: '/marketing',
  getParentRoute: () => rootRouteImport,
} as any)
const GiveawaysRoute = GiveawaysRouteImport.update({
  id: '/giveaways',
  path: '/giveaways',
  getParentRoute: () => rootRouteImport,
} as any)
const FinanceRoute = FinanceRouteImport.update({
  id: '/finance',
  path: '/finance',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientsRoute = ClientsRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientWithdrawalsRoute = ClientWithdrawalsRouteImport.update({
  id: '/client-withdrawals',
  path: '/client-withdrawals',
  getParentRoute: () => rootRouteImport,
} as any)
const CampaignsRoute = CampaignsRouteImport.update({
  id: '/campaigns',
  path: '/campaigns',
  getParentRoute: () => rootRouteImport,
} as any)
const BotsRoute = BotsRouteImport.update({
  id: '/bots',
  path: '/bots',
  getParentRoute: () => rootRouteImport,
} as any)
const BotImportRoute = BotImportRouteImport.update({
  id: '/bot-import',
  path: '/bot-import',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const BotIndexRoute = BotIndexRouteImport.update({
  id: '/bot/',
  path: '/bot/',
  getParentRoute: () => rootRouteImport,
} as any)
const WarmupRulesBotIdRoute = WarmupRulesBotIdRouteImport.update({
  id: '/warmup-rules/$botId',
  path: '/warmup-rules/$botId',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingBotRoute = OnboardingBotRouteImport.update({
  id: '/onboarding/bot',
  path: '/onboarding/bot',
  getParentRoute: () => rootRouteImport,
} as any)
const CampaignsCampaignIdRoute = CampaignsCampaignIdRouteImport.update({
  id: '/$campaignId',
  path: '/$campaignId',
  getParentRoute: () => CampaignsRoute,
} as any)
const BotsBotIdRoute = BotsBotIdRouteImport.update({
  id: '/$botId',
  path: '/$botId',
  getParentRoute: () => BotsRoute,
} as any)
const BotTemplatesRoute = BotTemplatesRouteImport.update({
  id: '/bot/templates',
  path: '/bot/templates',
  getParentRoute: () => rootRouteImport,
} as any)
const BotSettingsRoute = BotSettingsRouteImport.update({
  id: '/bot/settings',
  path: '/bot/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const BotBrandRoute = BotBrandRouteImport.update({
  id: '/bot/brand',
  path: '/bot/brand',
  getParentRoute: () => rootRouteImport,
} as any)
const BotWarmupBotIdRoute = BotWarmupBotIdRouteImport.update({
  id: '/bot-warmup/$botId',
  path: '/bot-warmup/$botId',
  getParentRoute: () => rootRouteImport,
} as any)
const BotTextsBotIdRoute = BotTextsBotIdRouteImport.update({
  id: '/bot-texts/$botId',
  path: '/bot-texts/$botId',
  getParentRoute: () => rootRouteImport,
} as any)
const BotReviewsBotIdRoute = BotReviewsBotIdRouteImport.update({
  id: '/bot-reviews/$botId',
  path: '/bot-reviews/$botId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/bot-import': typeof BotImportRoute
  '/bots': typeof BotsRouteWithChildren
  '/campaigns': typeof CampaignsRouteWithChildren
  '/client-withdrawals': typeof ClientWithdrawalsRoute
  '/clients': typeof ClientsRoute
  '/dashboard': typeof DashboardRoute
  '/finance': typeof FinanceRoute
  '/giveaways': typeof GiveawaysRoute
  '/marketing': typeof MarketingRoute
  '/mirrors': typeof MirrorsRoute
  '/more': typeof MoreRoute
  '/payouts': typeof PayoutsRoute
  '/pricing': typeof PricingRoute
  '/profile': typeof ProfileRoute
  '/referrals': typeof ReferralsRoute
  '/stats': typeof StatsRoute
  '/status': typeof StatusRoute
  '/subscriptions': typeof SubscriptionsRoute
  '/team': typeof TeamRoute
  '/vouchers': typeof VouchersRoute
  '/vpn-api': typeof VpnApiRoute
  '/bot-reviews/$botId': typeof BotReviewsBotIdRoute
  '/bot-texts/$botId': typeof BotTextsBotIdRoute
  '/bot-warmup/$botId': typeof BotWarmupBotIdRoute
  '/bot/brand': typeof BotBrandRoute
  '/bot/settings': typeof BotSettingsRoute
  '/bot/templates': typeof BotTemplatesRoute
  '/bots/$botId': typeof BotsBotIdRoute
  '/campaigns/$campaignId': typeof CampaignsCampaignIdRoute
  '/onboarding/bot': typeof OnboardingBotRoute
  '/warmup-rules/$botId': typeof WarmupRulesBotIdRoute
  '/bot/': typeof BotIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/bot-import': typeof BotImportRoute
  '/bots': typeof BotsRouteWithChildren
  '/campaigns': typeof CampaignsRouteWithChildren
  '/client-withdrawals': typeof ClientWithdrawalsRoute
  '/clients': typeof ClientsRoute
  '/dashboard': typeof DashboardRoute
  '/finance': typeof FinanceRoute
  '/giveaways': typeof GiveawaysRoute
  '/marketing': typeof MarketingRoute
  '/mirrors': typeof MirrorsRoute
  '/more': typeof MoreRoute
  '/payouts': typeof PayoutsRoute
  '/pricing': typeof PricingRoute
  '/profile': typeof ProfileRoute
  '/referrals': typeof ReferralsRoute
  '/stats': typeof StatsRoute
  '/status': typeof StatusRoute
  '/subscriptions': typeof SubscriptionsRoute
  '/team': typeof TeamRoute
  '/vouchers': typeof VouchersRoute
  '/vpn-api': typeof VpnApiRoute
  '/bot-reviews/$botId': typeof BotReviewsBotIdRoute
  '/bot-texts/$botId': typeof BotTextsBotIdRoute
  '/bot-warmup/$botId': typeof BotWarmupBotIdRoute
  '/bot/brand': typeof BotBrandRoute
  '/bot/settings': typeof BotSettingsRoute
  '/bot/templates': typeof BotTemplatesRoute
  '/bots/$botId': typeof BotsBotIdRoute
  '/campaigns/$campaignId': typeof CampaignsCampaignIdRoute
  '/onboarding/bot': typeof OnboardingBotRoute
  '/warmup-rules/$botId': typeof WarmupRulesBotIdRoute
  '/bot': typeof BotIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/bot-import': typeof BotImportRoute
  '/bots': typeof BotsRouteWithChildren
  '/campaigns': typeof CampaignsRouteWithChildren
  '/client-withdrawals': typeof ClientWithdrawalsRoute
  '/clients': typeof ClientsRoute
  '/dashboard': typeof DashboardRoute
  '/finance': typeof FinanceRoute
  '/giveaways': typeof GiveawaysRoute
  '/marketing': typeof MarketingRoute
  '/mirrors': typeof MirrorsRoute
  '/more': typeof MoreRoute
  '/payouts': typeof PayoutsRoute
  '/pricing': typeof PricingRoute
  '/profile': typeof ProfileRoute
  '/referrals': typeof ReferralsRoute
  '/stats': typeof StatsRoute
  '/status': typeof StatusRoute
  '/subscriptions': typeof SubscriptionsRoute
  '/team': typeof TeamRoute
  '/vouchers': typeof VouchersRoute
  '/vpn-api': typeof VpnApiRoute
  '/bot-reviews/$botId': typeof BotReviewsBotIdRoute
  '/bot-texts/$botId': typeof BotTextsBotIdRoute
  '/bot-warmup/$botId': typeof BotWarmupBotIdRoute
  '/bot/brand': typeof BotBrandRoute
  '/bot/settings': typeof BotSettingsRoute
  '/bot/templates': typeof BotTemplatesRoute
  '/bots/$botId': typeof BotsBotIdRoute
  '/campaigns/$campaignId': typeof CampaignsCampaignIdRoute
  '/onboarding/bot': typeof OnboardingBotRoute
  '/warmup-rules/$botId': typeof WarmupRulesBotIdRoute
  '/bot/': typeof BotIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/bot-import'
    | '/bots'
    | '/campaigns'
    | '/client-withdrawals'
    | '/clients'
    | '/dashboard'
    | '/finance'
    | '/giveaways'
    | '/marketing'
    | '/mirrors'
    | '/more'
    | '/payouts'
    | '/pricing'
    | '/profile'
    | '/referrals'
    | '/stats'
    | '/status'
    | '/subscriptions'
    | '/team'
    | '/vouchers'
    | '/vpn-api'
    | '/bot-reviews/$botId'
    | '/bot-texts/$botId'
    | '/bot-warmup/$botId'
    | '/bot/brand'
    | '/bot/settings'
    | '/bot/templates'
    | '/bots/$botId'
    | '/campaigns/$campaignId'
    | '/onboarding/bot'
    | '/warmup-rules/$botId'
    | '/bot/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/bot-import'
    | '/bots'
    | '/campaigns'
    | '/client-withdrawals'
    | '/clients'
    | '/dashboard'
    | '/finance'
    | '/giveaways'
    | '/marketing'
    | '/mirrors'
    | '/more'
    | '/payouts'
    | '/pricing'
    | '/profile'
    | '/referrals'
    | '/stats'
    | '/status'
    | '/subscriptions'
    | '/team'
    | '/vouchers'
    | '/vpn-api'
    | '/bot-reviews/$botId'
    | '/bot-texts/$botId'
    | '/bot-warmup/$botId'
    | '/bot/brand'
    | '/bot/settings'
    | '/bot/templates'
    | '/bots/$botId'
    | '/campaigns/$campaignId'
    | '/onboarding/bot'
    | '/warmup-rules/$botId'
    | '/bot'
  id:
    | '__root__'
    | '/'
    | '/bot-import'
    | '/bots'
    | '/campaigns'
    | '/client-withdrawals'
    | '/clients'
    | '/dashboard'
    | '/finance'
    | '/giveaways'
    | '/marketing'
    | '/mirrors'
    | '/more'
    | '/payouts'
    | '/pricing'
    | '/profile'
    | '/referrals'
    | '/stats'
    | '/status'
    | '/subscriptions'
    | '/team'
    | '/vouchers'
    | '/vpn-api'
    | '/bot-reviews/$botId'
    | '/bot-texts/$botId'
    | '/bot-warmup/$botId'
    | '/bot/brand'
    | '/bot/settings'
    | '/bot/templates'
    | '/bots/$botId'
    | '/campaigns/$campaignId'
    | '/onboarding/bot'
    | '/warmup-rules/$botId'
    | '/bot/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BotImportRoute: typeof BotImportRoute
  BotsRoute: typeof BotsRouteWithChildren
  CampaignsRoute: typeof CampaignsRouteWithChildren
  ClientWithdrawalsRoute: typeof ClientWithdrawalsRoute
  ClientsRoute: typeof ClientsRoute
  DashboardRoute: typeof DashboardRoute
  FinanceRoute: typeof FinanceRoute
  GiveawaysRoute: typeof GiveawaysRoute
  MarketingRoute: typeof MarketingRoute
  MirrorsRoute: typeof MirrorsRoute
  MoreRoute: typeof MoreRoute
  PayoutsRoute: typeof PayoutsRoute
  PricingRoute: typeof PricingRoute
  ProfileRoute: typeof ProfileRoute
  ReferralsRoute: typeof ReferralsRoute
  StatsRoute: typeof StatsRoute
  StatusRoute: typeof StatusRoute
  SubscriptionsRoute: typeof SubscriptionsRoute
  TeamRoute: typeof TeamRoute
  VouchersRoute: typeof VouchersRoute
  VpnApiRoute: typeof VpnApiRoute
  BotReviewsBotIdRoute: typeof BotReviewsBotIdRoute
  BotTextsBotIdRoute: typeof BotTextsBotIdRoute
  BotWarmupBotIdRoute: typeof BotWarmupBotIdRoute
  BotBrandRoute: typeof BotBrandRoute
  BotSettingsRoute: typeof BotSettingsRoute
  BotTemplatesRoute: typeof BotTemplatesRoute
  OnboardingBotRoute: typeof OnboardingBotRoute
  WarmupRulesBotIdRoute: typeof WarmupRulesBotIdRoute
  BotIndexRoute: typeof BotIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/vpn-api': {
      id: '/vpn-api'
      path: '/vpn-api'
      fullPath: '/vpn-api'
      preLoaderRoute: typeof VpnApiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vouchers': {
      id: '/vouchers'
      path: '/vouchers'
      fullPath: '/vouchers'
      preLoaderRoute: typeof VouchersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/team': {
      id: '/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof TeamRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subscriptions': {
      id: '/subscriptions'
      path: '/subscriptions'
      fullPath: '/subscriptions'
      preLoaderRoute: typeof SubscriptionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/status': {
      id: '/status'
      path: '/status'
      fullPath: '/status'
      preLoaderRoute: typeof StatusRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stats': {
      id: '/stats'
      path: '/stats'
      fullPath: '/stats'
      preLoaderRoute: typeof StatsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/referrals': {
      id: '/referrals'
      path: '/referrals'
      fullPath: '/referrals'
      preLoaderRoute: typeof ReferralsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payouts': {
      id: '/payouts'
      path: '/payouts'
      fullPath: '/payouts'
      preLoaderRoute: typeof PayoutsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/more': {
      id: '/more'
      path: '/more'
      fullPath: '/more'
      preLoaderRoute: typeof MoreRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mirrors': {
      id: '/mirrors'
      path: '/mirrors'
      fullPath: '/mirrors'
      preLoaderRoute: typeof MirrorsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketing': {
      id: '/marketing'
      path: '/marketing'
      fullPath: '/marketing'
      preLoaderRoute: typeof MarketingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/giveaways': {
      id: '/giveaways'
      path: '/giveaways'
      fullPath: '/giveaways'
      preLoaderRoute: typeof GiveawaysRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/finance': {
      id: '/finance'
      path: '/finance'
      fullPath: '/finance'
      preLoaderRoute: typeof FinanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clients': {
      id: '/clients'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof ClientsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/client-withdrawals': {
      id: '/client-withdrawals'
      path: '/client-withdrawals'
      fullPath: '/client-withdrawals'
      preLoaderRoute: typeof ClientWithdrawalsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/campaigns': {
      id: '/campaigns'
      path: '/campaigns'
      fullPath: '/campaigns'
      preLoaderRoute: typeof CampaignsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bots': {
      id: '/bots'
      path: '/bots'
      fullPath: '/bots'
      preLoaderRoute: typeof BotsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bot-import': {
      id: '/bot-import'
      path: '/bot-import'
      fullPath: '/bot-import'
      preLoaderRoute: typeof BotImportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bot/': {
      id: '/bot/'
      path: '/bot'
      fullPath: '/bot/'
      preLoaderRoute: typeof BotIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/warmup-rules/$botId': {
      id: '/warmup-rules/$botId'
      path: '/warmup-rules/$botId'
      fullPath: '/warmup-rules/$botId'
      preLoaderRoute: typeof WarmupRulesBotIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/bot': {
      id: '/onboarding/bot'
      path: '/onboarding/bot'
      fullPath: '/onboarding/bot'
      preLoaderRoute: typeof OnboardingBotRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/campaigns/$campaignId': {
      id: '/campaigns/$campaignId'
      path: '/$campaignId'
      fullPath: '/campaigns/$campaignId'
      preLoaderRoute: typeof CampaignsCampaignIdRouteImport
      parentRoute: typeof CampaignsRoute
    }
    '/bots/$botId': {
      id: '/bots/$botId'
      path: '/$botId'
      fullPath: '/bots/$botId'
      preLoaderRoute: typeof BotsBotIdRouteImport
      parentRoute: typeof BotsRoute
    }
    '/bot/templates': {
      id: '/bot/templates'
      path: '/bot/templates'
      fullPath: '/bot/templates'
      preLoaderRoute: typeof BotTemplatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bot/settings': {
      id: '/bot/settings'
      path: '/bot/settings'
      fullPath: '/bot/settings'
      preLoaderRoute: typeof BotSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bot/brand': {
      id: '/bot/brand'
      path: '/bot/brand'
      fullPath: '/bot/brand'
      preLoaderRoute: typeof BotBrandRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bot-warmup/$botId': {
      id: '/bot-warmup/$botId'
      path: '/bot-warmup/$botId'
      fullPath: '/bot-warmup/$botId'
      preLoaderRoute: typeof BotWarmupBotIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bot-texts/$botId': {
      id: '/bot-texts/$botId'
      path: '/bot-texts/$botId'
      fullPath: '/bot-texts/$botId'
      preLoaderRoute: typeof BotTextsBotIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bot-reviews/$botId': {
      id: '/bot-reviews/$botId'
      path: '/bot-reviews/$botId'
      fullPath: '/bot-reviews/$botId'
      preLoaderRoute: typeof BotReviewsBotIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface BotsRouteChildren {
  BotsBotIdRoute: typeof BotsBotIdRoute
}

const BotsRouteChildren: BotsRouteChildren = {
  BotsBotIdRoute: BotsBotIdRoute,
}

const BotsRouteWithChildren = BotsRoute._addFileChildren(BotsRouteChildren)

interface CampaignsRouteChildren {
  CampaignsCampaignIdRoute: typeof CampaignsCampaignIdRoute
}

const CampaignsRouteChildren: CampaignsRouteChildren = {
  CampaignsCampaignIdRoute: CampaignsCampaignIdRoute,
}

const CampaignsRouteWithChildren = CampaignsRoute._addFileChildren(
  CampaignsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BotImportRoute: BotImportRoute,
  BotsRoute: BotsRouteWithChildren,
  CampaignsRoute: CampaignsRouteWithChildren,
  ClientWithdrawalsRoute: ClientWithdrawalsRoute,
  ClientsRoute: ClientsRoute,
  DashboardRoute: DashboardRoute,
  FinanceRoute: FinanceRoute,
  GiveawaysRoute: GiveawaysRoute,
  MarketingRoute: MarketingRoute,
  MirrorsRoute: MirrorsRoute,
  MoreRoute: MoreRoute,
  PayoutsRoute: PayoutsRoute,
  PricingRoute: PricingRoute,
  ProfileRoute: ProfileRoute,
  ReferralsRoute: ReferralsRoute,
  StatsRoute: StatsRoute,
  StatusRoute: StatusRoute,
  SubscriptionsRoute: SubscriptionsRoute,
  TeamRoute: TeamRoute,
  VouchersRoute: VouchersRoute,
  VpnApiRoute: VpnApiRoute,
  BotReviewsBotIdRoute: BotReviewsBotIdRoute,
  BotTextsBotIdRoute: BotTextsBotIdRoute,
  BotWarmupBotIdRoute: BotWarmupBotIdRoute,
  BotBrandRoute: BotBrandRoute,
  BotSettingsRoute: BotSettingsRoute,
  BotTemplatesRoute: BotTemplatesRoute,
  OnboardingBotRoute: OnboardingBotRoute,
  WarmupRulesBotIdRoute: WarmupRulesBotIdRoute,
  BotIndexRoute: BotIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
